// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"bd8035c0","787":"57fa2fc9"}[chunkId] + ".chunk.js";
};